import { useId } from "react";

import { cn } from "@/lib/utils";

export function AddGameIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-[25px] text-white", className)}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill={`url(#${id})`} height="25" rx="12.5" width="25" />
      <path
        d="M6.37 12.5a.79.79 0 01.241-.579.778.778 0 01.579-.249h4.49V7.19a.79.79 0 01.241-.579.79.79 0 01.579-.241c.23 0 .425.08.586.241a.79.79 0 01.242.579v4.482h4.482c.225 0 .418.083.579.25a.79.79 0 01.241.578c0 .23-.08.425-.241.586a.802.802 0 01-.579.234h-4.482v4.497c0 .22-.08.41-.242.572a.798.798 0 01-.586.241.79.79 0 01-.579-.241.781.781 0 01-.241-.572V13.32H7.19a.802.802 0 01-.579-.234.798.798 0 01-.241-.586z"
        fill="currentColor"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="12.464"
          x2="12.464"
          y1="0"
          y2="25"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function ArticlesIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-5 text-white", className)}
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.117 16.912V4.527c0-.764.204-1.342.614-1.735.41-.398.968-.62 1.677-.664a46.1 46.1 0 002.789-.257c.896-.11 1.757-.238 2.581-.382a49.06 49.06 0 002.39-.49C13 .8 13.645.894 14.104 1.281c.46.382.689 1.008.689 1.876v12.128c0 .736-.127 1.295-.382 1.677-.254.387-.692.672-1.311.855a34.3 34.3 0 01-2.906.672c-.935.177-1.859.315-2.772.415-.908.1-1.826.174-2.756.224-.808.05-1.436-.122-1.884-.515-.443-.387-.664-.954-.664-1.701zM5.37 6.494a34.22 34.22 0 003.254-.357c.99-.16 1.967-.348 2.93-.564.21-.044.346-.116.406-.216a.6.6 0 00.1-.34.45.45 0 00-.158-.349c-.105-.1-.254-.13-.448-.091a51.19 51.19 0 01-2.847.548c-.974.16-2.056.28-3.246.357-.177.01-.307.066-.39.166a.564.564 0 00-.116.357c0 .138.047.257.141.357.094.1.219.143.374.132zm0 2.698a35.97 35.97 0 003.254-.365c.99-.16 1.967-.349 2.93-.565.21-.044.346-.116.406-.215.067-.1.1-.21.1-.332a.484.484 0 00-.158-.366c-.105-.1-.254-.127-.448-.083-.918.21-1.868.396-2.847.556-.974.155-2.056.272-3.246.35-.177.01-.307.065-.39.165a.552.552 0 00-.116.349c0 .15.047.274.141.373a.48.48 0 00.374.133zm0 2.69a35.963 35.963 0 003.254-.366c.99-.16 1.967-.348 2.93-.564.21-.044.346-.116.406-.216.067-.1.1-.21.1-.332a.474.474 0 00-.158-.357c-.105-.105-.254-.136-.448-.091a50.99 50.99 0 01-2.847.548 37.28 37.28 0 01-3.246.357c-.177.016-.307.074-.39.174a.551.551 0 00-.116.348c0 .144.047.266.141.366a.479.479 0 00.374.133zm0 2.68a30.925 30.925 0 001.776-.157c.492-.066.963-.136 1.411-.208a.535.535 0 00.34-.19.551.551 0 00.117-.332.475.475 0 00-.158-.357c-.105-.106-.26-.141-.465-.108-.393.066-.827.13-1.303.19-.47.056-1.046.103-1.727.142-.177.016-.307.074-.39.174a.53.53 0 00-.116.349c0 .144.047.265.141.365a.48.48 0 00.374.133zm3.602 5.33a38.05 38.05 0 002.175-.407 40.967 40.967 0 002.283-.548c.559-.16 1.026-.393 1.403-.697.381-.299.67-.689.863-1.17.194-.482.29-1.077.29-1.785V3.199c0-.138-.005-.274-.016-.407a16.606 16.606 0 00-.042-.44c.548.139.96.42 1.237.847.282.42.423.982.423 1.685v12.293c0 .902-.224 1.58-.672 2.034-.443.454-1.11.68-2 .68H8.973z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BlogIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-[25px] text-white", className)}
      viewBox="0 0 25 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.427 16.812v-5.387a.628.628 0 00-.175-.465.628.628 0 00-.464-.174h-3.072a.657.657 0 00-.473.174.629.629 0 00-.174.465v5.387h4.358zm-9.62-.282v-6.325l6.939-5.82c.337-.287.678-.287 1.02 0l6.94 5.82v6.325c0 .598-.177 1.065-.531 1.403-.354.337-.836.506-1.445.506H6.782c-.615 0-1.099-.169-1.453-.506-.349-.338-.523-.805-.523-1.403zm-2.69-7.462c0-.255.108-.474.323-.656l8.65-7.263c.36-.3.75-.449 1.17-.449.42 0 .808.15 1.162.449l8.642 7.263a.841.841 0 01.323.68.696.696 0 01-.249.565.883.883 0 01-.598.207.777.777 0 01-.365-.09 2.152 2.152 0 01-.323-.208L12.617 2.65a.546.546 0 00-.357-.15c-.121 0-.24.05-.357.15L3.661 9.566a2.565 2.565 0 01-.332.207.729.729 0 01-.357.091c-.266 0-.476-.077-.631-.232a.802.802 0 01-.224-.564zm15.265-4.026V3.008c0-.183.055-.33.166-.44a.607.607 0 01.448-.174h1.12a.59.59 0 01.449.174c.11.11.166.257.166.44v4.01l-2.35-1.976z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChatIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 w-[26px] text-white", className)}
      viewBox="0 0 26 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.907 19.322c-.293 0-.523-.093-.689-.278-.166-.186-.249-.44-.249-.762v-1.89h-.923c-.64 0-1.198-.122-1.677-.366a2.682 2.682 0 01-1.106-1.07c-.263-.468-.395-1.032-.395-1.691V6.416c0-.659.134-1.225.403-1.699a2.671 2.671 0 011.127-1.091c.484-.254 1.048-.38 1.692-.38h10.686c.67 0 1.243.126 1.722.38.483.249.854.613 1.113 1.091.259.474.388 1.04.388 1.7v1.069h-1.443V6.57c0-.64-.173-1.125-.52-1.457-.342-.337-.82-.506-1.435-.506H5.266c-.615 0-1.096.169-1.443.506-.342.332-.512.818-.512 1.457v6.511c0 .635.17 1.121.512 1.458.347.332.828.498 1.443.498h1.37c.18 0 .33.056.447.169.122.112.183.275.183.49v2.051l3.083-2.871.799 1.194-2.967 2.644a3.025 3.025 0 01-.674.461 1.33 1.33 0 01-.6.147zm12.15.886c-.19 0-.378-.056-.563-.168a4.725 4.725 0 01-.645-.47l-2.439-2.094h-2.497c-.65 0-1.209-.122-1.678-.366a2.545 2.545 0 01-1.084-1.033c-.249-.454-.373-.998-.373-1.633v-4.46c0-.645.124-1.197.373-1.656.254-.459.616-.81 1.084-1.055.47-.249 1.028-.373 1.678-.373h7.353c.625 0 1.172.124 1.64.373.47.245.836.596 1.1 1.055.263.46.395 1.01.395 1.655v4.46c0 .636-.13 1.18-.388 1.634a2.6 2.6 0 01-1.084 1.033c-.46.244-.996.366-1.612.366h-.33v1.677c0 .323-.082.579-.248.77-.161.19-.388.285-.681.285zm-.358-1.575V16.78c0-.215.058-.376.175-.483a.636.636 0 01.447-.169h.799c.57 0 1.023-.158 1.355-.476.332-.317.498-.778.498-1.384v-4.153c0-.605-.166-1.067-.498-1.384-.328-.322-.78-.483-1.355-.483h-7.054c-.58 0-1.037.16-1.37.483-.326.317-.49.779-.49 1.384l-.007 4.153c0 .61.166 1.074.498 1.392.332.312.788.468 1.37.468h2.314c.215 0 .395.035.542.103.151.063.31.168.476.315l2.3 2.087z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ClaimBusinessIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6", className)}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M4.944 2.314a2.39 2.39 0 00-.437.19c-.242.13-.457.371-1.655 1.843-.8.983-1.435 1.812-1.515 1.978-.131.274-.138.33-.154 1.287-.01.602.006 1.11.04 1.275.133.63.6 1.22 1.197 1.513.313.153.383.167.836.165.621-.003.972-.13 1.375-.498.61-.558.706-.896.706-2.478V6.43l.735-1.834.832-2.082L7 2.265l-.949.006c-.522.003-1.02.022-1.108.043zm3.677.068l-.836 2.092-.79 1.975.017 1.278.017 1.278.165.348c.229.484.524.785.998 1.02.371.183.42.194.893.194.472 0 .521-.011.893-.195.474-.234.769-.535.998-1.019l.165-.348.014-3.37.015-3.37H9.918c-1.25 0-1.252 0-1.297.117zm4.222 3.252l.015 3.371.165.348c.23.484.524.785.998 1.02.371.183.42.194.893.194.472 0 .521-.011.893-.195.474-.234.769-.535.998-1.019l.165-.348.017-1.278.017-1.278-.832-2.079-.83-2.079-1.257-.014-1.257-.014.015 3.371zm4.25-3.126l.834 2.087.734 1.835v1.16c0 1.581.097 1.92.707 2.477.403.368.754.495 1.376.498.456.002.524-.012.837-.166.597-.294 1.062-.882 1.194-1.512.035-.165.051-.673.041-1.275-.016-.958-.023-1.013-.155-1.287-.08-.166-.714-.995-1.516-1.98-1.292-1.587-1.4-1.706-1.71-1.874l-.331-.18-1.055-.017-1.055-.018.1.252zm-11.24 8.658c-.66.685-1.647 1.092-2.648 1.092h-.367l.013 4.733c.014 4.688.015 4.733.121 4.876.06.079.172.192.251.25.136.102.224.11 1.544.124l4.74.015H12s2.508-.003 2.5 0l.008-.003 1.308-.014c4.686-.014 4.817-.015 4.96-.121.078-.06.191-.172.25-.251.107-.143.108-.189.121-4.863l.014-4.72-.456-.003a4.149 4.149 0 01-.742-.072c-.693-.165-1.419-.582-1.865-1.07l-.26-.283-.334.327a3.672 3.672 0 01-5.175.005l-.33-.323-.329.323a3.671 3.671 0 01-5.177-.006 6.217 6.217 0 00-.342-.323l-.297.307z"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10.343 18.593l4.991-4.91a.793.793 0 011.11 0 .763.763 0 010 1.09l-5.547 5.457a.793.793 0 01-1.109 0L7.57 18.047a.763.763 0 010-1.09.793.793 0 011.109 0l1.664 1.636z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function DashboardIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5", className)}
      color="white.100"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.638 10.608c.133.62-.244 1.23-.834 1.46-2.595 1.009-4.607 2.927-5.483 5.28C-.202 18.75 1.054 20 2.55 20h14.89c1.497 0 2.752-1.25 2.23-2.652-.876-2.353-2.888-4.27-5.483-5.28-.59-.23-.967-.84-.834-1.46a1.35 1.35 0 01.335-.624c.97-1.057 1.571-2.528 1.571-4.154 0-3.22-2.357-5.83-5.264-5.83C7.09 0 4.732 2.61 4.732 5.83c0 1.626.601 3.097 1.571 4.154.162.177.285.39.335.624z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DiscordIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[17px] w-[21px] text-white", className)}
      viewBox="0 0 21 17"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.789 1.361A17.104 17.104 0 0013.456 0a12.72 12.72 0 00-.554 1.152 15.908 15.908 0 00-4.802 0C7.95.792 7.727.337 7.538 0a17.047 17.047 0 00-4.335 1.365C.46 5.508-.282 9.549.089 13.53a17.322 17.322 0 005.314 2.723c.428-.588.81-1.214 1.138-1.874a11.191 11.191 0 01-1.792-.872c.15-.111.297-.228.439-.348 3.455 1.617 7.21 1.617 10.624 0 .144.12.29.237.44.348-.569.342-1.17.636-1.796.874a13.15 13.15 0 001.138 1.874 17.284 17.284 0 005.317-2.725c.436-4.617-.745-8.62-3.122-12.17zM7.012 11.082c-1.038 0-1.888-.968-1.888-2.148 0-1.179.832-2.149 1.888-2.149 1.055 0 1.906.969 1.887 2.15.002 1.179-.832 2.147-1.887 2.147zm6.976 0c-1.037 0-1.887-.968-1.887-2.148 0-1.179.832-2.149 1.887-2.149 1.056 0 1.907.969 1.888 2.15 0 1.179-.832 2.147-1.888 2.147z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ExploreBusinessIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M2 4a2 2 0 012-2h16a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4zm14.456 0H7.692a.125.125 0 00-.136.114.126.126 0 00.111.139l6.8 1.46a.25.25 0 01.196.252v12.078a.251.251 0 01-.197.252l-6.799 1.452a.126.126 0 00-.11.139c.006.07.067.12.135.113h8.764a.25.25 0 00.246-.252V4.253A.25.25 0 0016.455 4zm-3.251 9.067c.148 0 .269-.24.269-.534 0-.294-.12-.533-.27-.533-.148 0-.268.239-.268.533 0 .295.12.534.269.534z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function ExternalIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4 w-[15px] text-white", className)}
      fill="none"
      viewBox="0 0 15 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.126 8.381v.2c0 1.68 0 2.52-.327 3.162a3 3 0 01-1.311 1.311c-.642.327-1.482.327-3.163.327h-1.65c-1.68 0-2.52 0-3.161-.327a3 3 0 01-1.312-1.31c-.327-.642-.327-1.482-.327-3.163v-1.65c0-1.68 0-2.52.327-3.162a3 3 0 011.312-1.31c.641-.328 1.481-.328 3.161-.328h.2M7.2 8.056l5.925-5.925m0 0H9.68m3.446 0v3.447"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
      />
    </svg>
  );
}

export function FeedbackIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.497 19.878c-.298 0-.53-.095-.696-.285-.161-.19-.242-.45-.242-.777v-1.801h-.3c-.708 0-1.316-.137-1.824-.41a2.835 2.835 0 01-1.164-1.172c-.269-.513-.403-1.133-.403-1.86V7.888c0-.728.134-1.346.403-1.853a2.77 2.77 0 011.164-1.18c.513-.273 1.138-.41 1.875-.41h9.338c.738 0 1.36.137 1.868.41a2.76 2.76 0 011.172 1.18c.268.507.403 1.125.403 1.853v5.683c0 .728-.135 1.348-.403 1.86a2.77 2.77 0 01-1.172 1.173c-.508.273-1.13.41-1.868.41h-4.43l-2.506 2.219c-.249.22-.463.38-.644.483a1.076 1.076 0 01-.571.161zm.351-1.618l2.33-2.3c.15-.156.292-.259.424-.308a1.51 1.51 0 01.542-.08h4.468c.688 0 1.199-.171 1.53-.513.338-.347.506-.86.506-1.538V7.933c0-.674-.168-1.182-.505-1.524-.332-.346-.843-.52-1.531-.52H7.347c-.689 0-1.201.173-1.538.52-.332.342-.498.85-.498 1.524v5.588c0 .679.166 1.191.498 1.538.337.342.85.513 1.538.513h.908c.205 0 .354.046.447.139.097.088.146.242.146.461v2.088zm3.135-6.314c-.425 0-.645-.215-.66-.644l-.102-3.56a.656.656 0 01.198-.527.758.758 0 01.55-.205c.224 0 .41.07.556.212.146.137.215.31.205.52l-.117 3.56c-.01.43-.22.644-.63.644zm0 2.432a.897.897 0 01-.615-.227.763.763 0 01-.25-.579c0-.23.084-.42.25-.571a.88.88 0 01.615-.234.86.86 0 01.6.227.738.738 0 01.257.578.739.739 0 01-.256.579.877.877 0 01-.601.227z"
        fill="currentColor"
      />
    </svg>
  );
}

export function GiftCardIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-6 w-6.5 text-white", className)}
      fill="none"
      viewBox="0 0 26 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.777 11.514h6.267q-.554-.255-.984-.633a3 3 0 0 1-.668-.853 2.3 2.3 0 0 1-.238-1.037q0-.967.633-1.59.633-.633 1.573-.633.554 0 1.055.22t.914.632q.422.405.703.967v-4.28h1.064v4.28q.29-.562.703-.967.422-.413.923-.633.5-.22 1.046-.22.948 0 1.573.633.633.624.633 1.591 0 .554-.238 1.037-.236.474-.668.853-.42.378-.984.633h6.188v.966h-8.324q.195.405.572.87.386.457.87.88.492.413 1.002.703.518.28.975.334.343.035.527.237a.7.7 0 0 1 .185.51.7.7 0 0 1-.22.51q-.21.22-.589.166-.51-.078-1.125-.386a7 7 0 0 1-1.221-.809 7 7 0 0 1-1.072-1.107q-.467-.615-.686-1.292h-.07v5.88h-1.064v-5.88h-.061a4.3 4.3 0 0 1-.695 1.292q-.466.615-1.072 1.107a6.7 6.7 0 0 1-1.222.809q-.615.308-1.116.386-.378.054-.597-.167a.7.7 0 0 1-.211-.51q0-.315.184-.51.185-.201.519-.236.457-.054.975-.334.519-.29 1.002-.703.492-.423.87-.88.387-.465.58-.87h-8.41zm8.833-.132h.264v-.246q0-.633-.193-1.196a3.3 3.3 0 0 0-.536-.993 2.6 2.6 0 0 0-.783-.685 1.9 1.9 0 0 0-.931-.246q-.476 0-.756.29-.282.28-.281.782 0 .412.254.826.255.405.704.738.447.326 1.028.528.58.202 1.23.202m1.908 0q.659 0 1.239-.202t1.02-.528q.447-.333.703-.738.255-.412.254-.826 0-.501-.28-.782-.273-.29-.757-.29-.483 0-.923.246a2.6 2.6 0 0 0-.782.685q-.342.43-.545.993a3.7 3.7 0 0 0-.193 1.196v.246zM5 19.169q-1.38 0-2.074-.686-.686-.676-.686-2.03V6.882q0-1.362.686-2.04Q3.62 4.159 5 4.158h15.135q1.38 0 2.065.686.694.685.694 2.039v9.571q.001 1.354-.694 2.03-.685.686-2.065.686zm.018-1.415h15.1q.65 0 1.001-.343.36-.351.36-1.037V6.961q0-.686-.36-1.037-.351-.352-1.002-.352h-15.1q-.659 0-1.01.352-.352.351-.352 1.037v9.413q0 .686.352 1.037.351.343 1.01.343"
        fill="currentColor"
      />
    </svg>
  );
}

export function MeetupIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[25px] text-white", className)}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.39 18.933c-1.246 0-1.869-.42-1.869-1.26 0-.497.15-1.02.447-1.567.303-.547.735-1.057 1.297-1.53.566-.474 1.245-.857 2.036-1.15.79-.298 1.677-.447 2.659-.447.98 0 1.867.149 2.658.447.796.293 1.475.676 2.036 1.15.562.473.991.983 1.29 1.53.302.547.454 1.07.454 1.568 0 .84-.625 1.26-1.875 1.26h-9.134zm-.242-1.267h9.616c.088 0 .15-.014.183-.044.04-.029.059-.078.059-.146 0-.278-.11-.6-.33-.967-.22-.366-.547-.72-.981-1.062-.43-.347-.96-.632-1.59-.857-.625-.23-1.34-.344-2.146-.344-.81 0-1.528.115-2.153.344-.625.225-1.152.51-1.582.857-.43.342-.757.696-.981 1.062-.22.366-.33.689-.33.967 0 .068.017.117.051.146.04.03.1.044.184.044zm4.812-5.537a2.93 2.93 0 01-1.612-.469 3.505 3.505 0 01-1.157-1.26 3.576 3.576 0 01-.432-1.743c0-.625.144-1.193.432-1.706a3.4 3.4 0 011.157-1.238 2.963 2.963 0 011.611-.461 2.99 2.99 0 011.62.454c.487.303.873.71 1.156 1.223a3.44 3.44 0 01.433 1.714c0 .64-.145 1.223-.433 1.75-.288.528-.676.95-1.164 1.267a2.906 2.906 0 01-1.612.47zm0-1.274c.346 0 .661-.098.944-.293.284-.2.51-.466.681-.799.171-.336.257-.71.257-1.12 0-.4-.086-.762-.257-1.084a2.022 2.022 0 00-.68-.762 1.687 1.687 0 00-.946-.278 1.67 1.67 0 00-.937.285 2.08 2.08 0 00-.681.77 2.224 2.224 0 00-.25 1.083c0 .41.086.782.257 1.114.171.332.398.595.681.79.288.196.598.294.93.294zM3.441 18.933c-.522 0-.915-.11-1.179-.33-.263-.219-.395-.546-.395-.98 0-.611.144-1.195.432-1.751a4.99 4.99 0 011.208-1.487 5.773 5.773 0 011.787-1.033 6.158 6.158 0 012.176-.38c.38 0 .759.034 1.135.102a5.9 5.9 0 012.095.784c-.2.127-.379.268-.535.425a2.995 2.995 0 00-.41.49 3.558 3.558 0 00-.696-.3 5.004 5.004 0 00-.776-.19 4.91 4.91 0 00-2.468.205c-.518.18-.977.427-1.378.74a3.76 3.76 0 00-.937 1.061c-.225.39-.337.796-.337 1.216 0 .064.015.11.044.14.034.029.088.043.161.043h5.15a1.29 1.29 0 00.138.718c.117.24.276.415.476.527h-5.69zm4.036-6.73c-.513 0-.981-.137-1.406-.41a3.043 3.043 0 01-1.011-1.1 3.185 3.185 0 01-.373-1.53 2.977 2.977 0 011.384-2.585 2.54 2.54 0 011.406-.41c.513 0 .979.134 1.399.402.425.269.762.628 1.01 1.077.255.449.382.95.382 1.501a3.15 3.15 0 01-.381 1.538 3.024 3.024 0 01-1.011 1.106 2.51 2.51 0 01-1.399.41zm0-1.253c.278 0 .535-.078.77-.234a1.75 1.75 0 00.563-.652 1.96 1.96 0 00.212-.916c0-.322-.07-.613-.212-.871a1.602 1.602 0 00-.557-.623 1.37 1.37 0 00-.776-.234 1.37 1.37 0 00-.776.234 1.645 1.645 0 00-.564.63 1.819 1.819 0 00-.198.879c0 .327.068.627.205.9.142.274.33.491.564.653.234.156.49.234.769.234z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MenuIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-3 w-[15px] text-white", className)}
      fill="none"
      viewBox="0 0 15 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 11h13M1 1h13H1zm0 5h13H1z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function NewsIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-6 text-white", className)}
      viewBox="0 0 24 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.117 9.508c0-.388.077-.717.232-.988.16-.277.376-.484.648-.623.27-.138.58-.207.93-.207h.34v9.155c0 .227-.05.418-.15.573a.92.92 0 01-.398.357 1.2 1.2 0 01-.523.133 1.19 1.19 0 01-.54-.125.989.989 0 01-.39-.365c-.1-.155-.15-.346-.15-.573V9.508zm2.938 9.745c.31-.166.526-.38.648-.64.121-.254.182-.594.182-1.02V3.979c0-.89.23-1.563.69-2.017.459-.454 1.136-.68 2.033-.68h9.587c.902 0 1.583.226 2.042.68.46.454.69 1.126.69 2.017v12.576c0 .885-.23 1.555-.69 2.009-.459.459-1.14.689-2.042.689H5.055zm4.35-12.8h8.01a.517.517 0 00.39-.166.543.543 0 00.166-.399.507.507 0 00-.166-.381.53.53 0 00-.39-.158h-8.01a.568.568 0 00-.407.158.52.52 0 00-.158.381.553.553 0 00.564.564zm0 2.864h8.01c.155 0 .285-.05.39-.15a.526.526 0 00.166-.398.516.516 0 00-.166-.39.517.517 0 00-.39-.166h-8.01a.553.553 0 00-.565.556c0 .16.053.293.158.398.11.1.246.15.407.15zm5.047 2.88h2.963a.53.53 0 00.39-.158.52.52 0 00.158-.382.55.55 0 00-.158-.406.53.53 0 00-.39-.158h-2.963a.54.54 0 00-.556.564.54.54 0 00.556.54zm0 2.897h2.963a.53.53 0 00.39-.158.52.52 0 00.158-.382.54.54 0 00-.158-.398.517.517 0 00-.39-.166h-2.963a.527.527 0 00-.399.166.54.54 0 00-.158.398.54.54 0 00.556.54zm-4.624.033h1.992c.31 0 .554-.088.73-.266.178-.177.266-.42.266-.73v-2.042c0-.31-.088-.553-.265-.73-.177-.178-.42-.266-.73-.266H9.827c-.315 0-.562.088-.739.266-.171.177-.257.42-.257.73v2.042c0 .31.086.553.257.73.177.178.424.266.74.266z"
        fill="currentColor"
      />
    </svg>
  );
}

export function OperatorsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-[23px] text-white", className)}
      viewBox="0 0 23 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.213 19.552c-.631 0-1.123-.172-1.478-.515-.354-.343-.53-.822-.53-1.436v-6.583c.265.127.541.227.83.3.292.066.597.099.912.099a3.582 3.582 0 002.175-.723 3.582 3.582 0 002.175.722c.41 0 .797-.063 1.162-.19.37-.128.706-.302 1.004-.523.305.221.64.396 1.005.523.365.127.755.19 1.17.19.41 0 .797-.063 1.162-.19a3.842 3.842 0 001.013-.523 3.582 3.582 0 002.167.714c.315 0 .62-.039.913-.117.298-.077.572-.182.821-.315v6.616c0 .614-.174 1.093-.523 1.436-.348.343-.838.515-1.469.515H5.212zm.98-1.495h4.556v-4.275a.628.628 0 00-.174-.464.628.628 0 00-.465-.175H6.84c-.2 0-.357.058-.473.175a.628.628 0 00-.175.464v4.275zm7.03-1.801h3.362c.188 0 .34-.058.456-.174a.613.613 0 00.183-.465v-2.291a.6.6 0 00-.183-.457.602.602 0 00-.456-.182h-3.362a.64.64 0 00-.473.182.617.617 0 00-.174.457v2.29c0 .195.058.35.174.466.122.116.28.174.473.174zM4.208 2.958v-.166c0-.559.167-1.001.499-1.328.337-.332.794-.498 1.37-.498h10.707c.57 0 1.021.166 1.353.498.332.327.498.77.498 1.328v.166H4.208zm-1.942 4.11c.017-.034.033-.065.05-.092l.05-.1L4 3.863h14.85l1.635 3.013.05.1c.017.027.033.058.05.091H2.266zm2.648 3.444c-.515 0-.985-.105-1.411-.316a2.862 2.862 0 01-1.013-.838 1.892 1.892 0 01-.373-1.12v-.274h18.627v.132c0 .399-.125.783-.374 1.154a2.926 2.926 0 01-1.013.905 2.86 2.86 0 01-1.419.357c-.448 0-.86-.094-1.237-.282a2.72 2.72 0 01-.921-.772 2.727 2.727 0 01-2.183 1.054c-.443 0-.852-.094-1.229-.282a2.78 2.78 0 01-.938-.772 2.78 2.78 0 01-.938.772 2.727 2.727 0 01-1.237.282c-.448 0-.86-.094-1.236-.282a2.803 2.803 0 01-.93-.772 2.78 2.78 0 01-.938.772 2.727 2.727 0 01-1.237.282z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PhoneIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[25px] text-white", className)}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.186 20.791c-.83 0-1.696-.158-2.598-.473-.897-.316-1.81-.78-2.74-1.395-.924-.614-1.845-1.375-2.764-2.282-.918-.913-1.687-1.835-2.307-2.764-.62-.936-1.088-1.852-1.403-2.748-.31-.897-.465-1.754-.465-2.573 0-.753.11-1.39.332-1.91.227-.525.587-1.015 1.08-1.469a5.949 5.949 0 00.199-.166c.547-.487 1.092-.725 1.635-.714.315.006.614.094.896.266.288.172.56.437.814.797l1.751 2.507c.266.387.399.794.399 1.22.005.42-.166.805-.515 1.154l-.614.614a.572.572 0 00-.175.324c-.005.1.03.21.108.332.111.171.247.357.407.556.166.2.343.404.531.614a24.194 24.194 0 001.228 1.22c.239.21.469.407.69.59.221.182.406.324.556.423a.54.54 0 00.34.125c.105-.011.21-.072.316-.183l.614-.614c.354-.349.742-.52 1.162-.515.42 0 .825.133 1.212.399l2.474 1.718c.37.254.642.525.813.813.177.282.266.578.266.888 0 .26-.061.532-.183.814a3.198 3.198 0 01-.639.938 1.476 1.476 0 01-.091.1c-.443.487-.927.84-1.453 1.062-.52.221-1.146.332-1.876.332zm0-1.395a3.289 3.289 0 001.245-.248 2.53 2.53 0 00.98-.706.592.592 0 00.083-.083c.022-.028.044-.058.066-.091.205-.238.307-.476.307-.714a.72.72 0 00-.348-.623l-2.3-1.527a.756.756 0 00-.448-.133c-.155 0-.302.072-.44.216l-.664.672c-.304.31-.625.465-.963.465-.332 0-.64-.1-.921-.299a10.912 10.912 0 01-.723-.564 44.7 44.7 0 01-.854-.756 37.505 37.505 0 01-.797-.772 20.5 20.5 0 01-1.096-1.153c-.37-.427-.67-.8-.897-1.121a1.513 1.513 0 01-.307-.921c.006-.338.166-.659.482-.963l.664-.664c.138-.139.21-.283.216-.432a.718.718 0 00-.133-.457L7.778 6.19a.702.702 0 00-.623-.349.859.859 0 00-.357.083c-.122.05-.24.125-.357.224a.597.597 0 01-.091.075.338.338 0 00-.083.075 2.608 2.608 0 00-.714.98c-.16.376-.244.788-.25 1.236-.01.703.142 1.461.457 2.275a12.2 12.2 0 001.353 2.473c.581.83 1.256 1.627 2.026 2.39a18.507 18.507 0 002.365 1.985 11.886 11.886 0 002.424 1.311c.803.316 1.555.465 2.258.448z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ProfileIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[30px] text-white", className)}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.008 30c2.048 0 3.978-.396 5.79-1.189a15.26 15.26 0 004.786-3.242 15.31 15.31 0 003.243-4.771C29.609 18.986 30 17.05 30 14.992c0-2.048-.396-3.978-1.189-5.79a15.26 15.26 0 00-3.242-4.786 15.26 15.26 0 00-4.787-3.243C18.971.391 17.041 0 14.992 0c-2.048 0-3.978.391-5.79 1.173a15.499 15.499 0 00-4.786 3.243 15.26 15.26 0 00-3.243 4.786C.391 11.014 0 12.944 0 14.992c0 2.059.391 3.994 1.173 5.806a15.532 15.532 0 003.258 4.77 15.31 15.31 0 004.771 3.243C11.014 29.604 12.95 30 15.008 30zm-.016-2.347a12.43 12.43 0 01-3.288-.448A13.425 13.425 0 018.6 25.924 11.256 11.256 0 016.022 23.9c.545-.834 1.266-1.544 2.161-2.13.906-.598 1.935-1.05 3.088-1.36a14.012 14.012 0 013.721-.478 14.2 14.2 0 013.69.463c1.153.31 2.183.762 3.088 1.359.906.587 1.632 1.302 2.178 2.146a10.844 10.844 0 01-2.579 2.023c-.968.556-1.997.983-3.088 1.281a12.412 12.412 0 01-3.289.448zm0-10.206a4.784 4.784 0 01-2.563-.74 5.432 5.432 0 01-1.822-1.977c-.442-.834-.664-1.781-.664-2.841 0-.988.222-1.894.664-2.718a5.432 5.432 0 011.822-1.976 4.657 4.657 0 012.563-.741c.937 0 1.786.247 2.548.741a5.432 5.432 0 011.822 1.976c.453.824.68 1.73.68 2.718 0 1.06-.227 2.012-.68 2.856a5.275 5.275 0 01-1.807 1.992c-.761.484-1.616.72-2.563.71z"
        fill="currentColor"
      />
    </svg>
  );
}
